// Get every element in the dom that have the class cart-item__remove
// add an event listener to each of them
// when page is ready
document.addEventListener("DOMContentLoaded", function() {

const cartItemRemoveButtons = document.querySelectorAll('.cart-item__remove');
    document.addEventListener("clickgear:cart:updated", function (evt) {
        window.location.reload();
    });

    cartItemRemoveButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
        const cartItemId = event.target.getAttribute('data-variant_id');
        const cart_protector =  JSON.parse(document.querySelector('#cart_protector').innerHTML)
        document.cart.updateItem(cartItemId, 0).then(() => {
            if (cartItemId != cart_protector.trigger_id) {
                window.location.reload();
            }
        });
    });
    })
});